import { Link } from 'react-router-dom'
import logoSrc from '@/assets/logo.svg'

export function LandingFooter() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="relative z-10 px-4 pb-10 pt-6 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="h-px bg-gradient-to-r from-transparent via-white/12 to-transparent" />
        <div className="flex flex-col items-center justify-between gap-4 py-8 text-center sm:flex-row sm:text-left">
          <Link to="/" className="flex items-center gap-1">
            <img src={logoSrc} alt="LinkToCreative" className="h-[4.25rem] object-contain brightness-0 invert" />
            <span className="bg-gradient-to-r from-white via-slate-200 to-slate-400 bg-clip-text text-xl font-bold font-brand tracking-tight text-transparent">
              LinkToCreative
            </span>
          </Link>
          <p className="text-sm text-slate-500">
            &copy; {currentYear} LinkToCreative. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  )
}
